/* eslint-disable prettier/prettier */
import { MyThunkResult } from 'store';

import { citiesSuccessful, citiesError, citiesRequest } from 'action-creators/cities';
import { CityRequestResponse } from 'models/city';
import { getCurrentLanguage } from 'utils/generic';
import { getLanguageWithoutRegion } from 'utils/i18n';

import { axiosConfig, rappiServicesTravelSearchCities } from '../api';

export const searchCities =
  (text: string): MyThunkResult<Promise<void>> =>
  async (dispatch, getState) => {
    try {
      dispatch(citiesRequest());
      const { country } = getState().i18n;
      const currentLanguage = country ? getLanguageWithoutRegion(getCurrentLanguage()) : 'ES';

      const { data } = await rappiServicesTravelSearchCities.get<CityRequestResponse>('', {
        params: {
          query: text.sanitize(),
          lang: currentLanguage.toUpperCase(),
          countrycode: '',
          type: '',
        },
        ...axiosConfig,
      });

      dispatch(citiesSuccessful(data.cities));
    } catch (ex) {
      dispatch(citiesError(ex));
    }
  };
